const React = require("react"),
    PropTypes = require('prop-types');
const {Row, Col, Alert, Button, Table, ButtonGroup} = require("react-bootstrap");
const I18n = require("components/widgets/I18n"),
    messages = require("i18n/messages"),
    TextCenter = require("components/widgets/TextCenter"),
    FontAwesome = require("components/widgets/FontAwesome"),
    ModalBasic = require ("components/modals/ModalBasic"),
    ValidInput = require("components/form/ValidInput");

const { TournamentRound } = require("parse/_Domain");

const tournamentActions = require("actions/TournamentManagerActions");
const {ModalBasicContext}  = require("components/modals/ModalBasicContext");

const TournamentConfigFinalModal = ({tournament, tRound }) =>  {
    return (
        <ModalBasic
            title={<TextCenter>Config: {tRound.getName()}</TextCenter>}
            buttonStyle={"default"}
            buttonChildren={<FontAwesome icon="cogs"/>}>
            <TournamentConfigFinalForm tournament={tournament} tRound={tRound}/>
        </ModalBasic>
    )
};
TournamentConfigFinalModal.propTypes = {
    tournament:PropTypes.object.isRequired,
    tRound: PropTypes.object.isRequired
};
class TournamentConfigFinalForm extends React.Component {
    constructor(props) {
        super(props);
        this.clickedSave = this.clickedSave.bind(this);
        this.setFinalState = this.setFinalState.bind(this);
        let tFinalConfig = this.props.tRound.getFinalConfig();

        this.state = {
            finalConfig: tFinalConfig,
            changed: false
        }
    }
    clickedSave(e) {
        const {closeFct, disableSubmitFct} = this.context;
        const {tRound} = this.props;
        const {changed, finalConfig} = this.state;
        e.preventDefault();
        disableSubmitFct(true);
        //  build object
        if (changed) {
            tRound.setFinalConfig(finalConfig);
            tournamentActions.saveTournamentRound(tRound);
        }
        closeFct();
    }
    setFinalState(value) {
        let tFinalConfig = this.state.finalConfig;
        tFinalConfig.eState = value;
        this.setState({finalConfig: tFinalConfig, changed:true});
    }
    render() {
        const {error, submitDisabled} = this.context;
        const validateNow = error && error.length > 0;
        const {finalConfig} = this.state;
        const {tournament, tRound} = this.props;
        return (
            <form action="#">
                <Row>
                    {
                        tRound.isFinalEliminationGroupPhase() ? <Col sm={12}>
                            <p><strong><I18n code="tournament.round.type.FEG.defRoundName"/></strong></p>
                            <p><I18n code="tournament.manager.round.amount.match"/>: {tRound.getMatchTargetAmounts()}</p>
                            <p>({finalConfig.groupCounter.length}) <I18n code="tournament.final.matches.group"/> TODO</p>
                            <p>({finalConfig.defMatchPoints[0]}/{finalConfig.defMatchPoints[1]}/{finalConfig.defMatchPoints[2]}) Punkte bei Sieg/Gleichstand/Niederlage TODO</p>
                        </Col> :null
                    }
                    {
                        tRound.isFinalEliminationFinalPhase() ? <Col sm={12}>
                            <p><strong><I18n code="tournament.round.type.FEF.defRoundName"/></strong></p>
                            <p><I18n code="tournament.manager.round.amount.match"/>: {tRound.getMatchTargetAmounts()}</p>
                            <p><I18n code="tournament.final.matches.final"/></p>
                            <p>({finalConfig.defMatchPoints[0]}/{finalConfig.defMatchPoints[2]}) Punkte bei Sieg/Niederlage TODO</p>
                            <h3>Choose current state</h3>
                            <TournamentFinalStateButton finalConfig={finalConfig} eState={TournamentRound.prototype.elimination.stateHalf} setFinalState={this.setFinalState}/>
                            <TournamentFinalStateButton finalConfig={finalConfig} eState={TournamentRound.prototype.elimination.stateFinal} setFinalState={this.setFinalState}/><br/><br/>
                        </Col> :null
                    }


                    <Col xs={12}>
                        {error == null ? null : <Alert bsStyle="danger">{error.message}</Alert>}
                        <Button onClick={this.clickedSave} disabled={submitDisabled} block bsStyle="success">
                            <I18n code={"modal.button.save"}/>
                        </Button>
                    </Col>
                </Row>
            </form>
        );
    }
}
TournamentConfigFinalForm.propTypes = {
    tournament:PropTypes.object.isRequired,
    tRound: PropTypes.object.isRequired
};
const TournamentFinalStateButton = ({finalConfig, eState, setFinalState }) =>  {
    let disabled = finalConfig != null && finalConfig.eState === eState
    return <Button bsStyle={disabled ? "success" : "default"} disabled={disabled}
            onClick={() => setFinalState(eState)}>
        <I18n code={"tournament.final.estate." + eState}/>
    </Button>
}
TournamentConfigFinalForm.contextType = ModalBasicContext;
module.exports = TournamentConfigFinalModal;
